// extracted by mini-css-extract-plugin
export default {"tableContainer":"AccountStamentTable_tableContainer__czGjv","customTable":"AccountStamentTable_customTable__cAaBF","stickyFooter":"AccountStamentTable_stickyFooter__OIIM0"};